import { connect } from "react-redux";
import React, { useEffect } from "react";
import CourseExplorer from "./courseExplorer.js";
import { getUpcomingCourses } from "../../actions/courses_actions.js";
import { selectCourses } from "../selectors/course_selectors.js";

const CourseExplorerContainer = ({ courses, loaded, load }) => {
  useEffect(() => {
    if (!loaded) load();
  }, [loaded, load]);

  return <CourseExplorer courses={courses} />;
};

const mapStateToProps = (state) => ({
  courses: selectCourses(state),
  loaded: !!(state.entities?.courses?.loaded || state.courses?.loaded),
});

const mapDispatchToProps = (dispatch) => ({
  load: () => dispatch(getUpcomingCourses()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CourseExplorerContainer);
